module.exports = __webpack_public_path__ + "static/media/U1-T2-1-4.3cc4fa67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-4.svg
// module id = 529
// module chunks = 0